import styles from './styles.module.scss';
import { FC, Props } from './typings';
import UpssAnimation from 'assets/upss.json';
import Lottie from 'lottie-react';
import { useTranslation } from 'react-i18next';

const ErrorScreen: FC<Props> = ({ text }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.error}>
      <div className={styles.titleWrapper}>
        <div className={styles.title}>{t("errors.upss")}</div>!
      </div>
      <div className={styles.body}>
        {text ? text : <>{t("errors.loadFileFailed")}</>}
      </div>
      <div className={styles.cat}>
        <Lottie
          className={styles.kittyCat}
          animationData={UpssAnimation}
          loop={true}
        />
      </div>
    </div>
  );
};

export default ErrorScreen;
